import { useRef } from "react";

const AlertPane = (props) => {
    let className;
    const ref = useRef();

    if (props.state === 'error') {
        className = "p-4 mb-4 text-red-800 border border-red-300 rounded-2xl bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800";
    } else if (props.state === 'success') {
        className = "p-4 mb-4 text-green-800 border border-green-300 rounded-2xl bg-green-50 dark:bg-gray-800 dark:text-green-400 dark:border-green-800";
    } else {
        className = "p-4 mb-4 text-blue-800 border border-blue-300 rounded-2xl bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800"
    }

    return (
        <div className={`${className} transition-all duration-300 ease-in-out animate-pulse`} role="alert" ref={ref}>
            <div className="flex items-center">
                <svg className="inline-block shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                </svg>
                <h3 className="text-lg flex-1 font-medium">{props.children}</h3>
            </div>
        </div>
    )
};

export default AlertPane;

